import { Link } from "react-router-dom";
import { emergencyHelplines } from "@/mocks/siteContent";
import useReveal from "@/hooks/useReveal";

export default function EmergencyHero() {
  const reveal = useReveal<HTMLDivElement>(0.1);

  return (
    <section className="relative overflow-hidden bg-primary-950">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -left-24 -top-16 h-64 w-64 rounded-full bg-red-600/25 blur-3xl" />
        <div className="absolute -right-20 bottom-0 h-72 w-72 rounded-full bg-accent-500/10 blur-3xl" />
      </div>

      <div className="relative mx-auto w-full max-w-[1400px] px-6 py-12 md:py-16">
        <nav
          className="flex items-center gap-2 text-xs text-background-300"
          aria-label="Breadcrumb"
        >
          <Link to="/" className="transition-colors hover:text-accent-300">
            Home
          </Link>
          <span className="flex h-3.5 w-3.5 items-center justify-center">
            <i className="ri-arrow-right-s-line text-sm" />
          </span>
          <span className="font-medium text-background-100">Emergency Services</span>
        </nav>

        <span className="mt-5 inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-red-400/40 bg-red-600/20 px-3.5 py-1.5 text-[11px] font-bold uppercase tracking-[0.16em] text-red-100">
          <span className="flex h-2 w-2 items-center justify-center">
            <span className="h-2 w-2 animate-pulse rounded-full bg-red-400" />
          </span>
          24&times;7 Emergency Directory
        </span>

        <h1 className="mt-4 max-w-3xl font-heading text-3xl font-extrabold leading-tight text-background-50 md:text-4xl">
          Emergency &amp; essential services across coastal Karnataka
        </h1>
        <p className="mt-4 max-w-2xl text-sm leading-relaxed text-background-200 md:text-base">
          Call a national helpline for immediate help, or jump straight to verified hospitals,
          pharmacies, blood banks and diagnostic labs near you in South Canara, Udupi and North
          Canara.
        </p>

        <div ref={reveal.ref} className="mt-9 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
          {emergencyHelplines.map((line, index) => (
            <a
              key={line.id}
              href={`tel:${line.number}`}
              title={`Call ${line.number} — ${line.label}`}
              className={`group flex cursor-pointer items-center gap-3 rounded-lg border border-background-50/15 bg-background-50/10 p-4 backdrop-blur transition-colors hover:border-red-400 hover:bg-background-50/15 ${
                reveal.visible ? "animate-fade-up" : "opacity-0"
              }`}
              style={{ animationDelay: `${index * 70}ms` }}
            >
              <span className="flex h-12 w-12 flex-none items-center justify-center rounded-md bg-red-600 text-white">
                <i className={`${line.icon} text-xl`} />
              </span>
              <span className="min-w-0">
                <span className="block font-heading text-2xl font-extrabold leading-none text-background-50">
                  {line.number}
                </span>
                <span className="mt-1 block text-xs font-semibold text-background-100">
                  {line.label}
                </span>
                <span className="mt-0.5 block text-[11px] leading-snug text-background-300">
                  {line.note}
                </span>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}